import { Component, Input, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AsyncPipe, Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';

import { selectCurrentCarImagesDatas } from 'src/app/common/store/state/app.state';

import { FilesActions } from 'src/app/common/store/actions/files.actions';
import { DomSanitizer } from '@angular/platform-browser';
import { FileData } from '../../models/file-data.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-image-carousel',
    templateUrl: './image-carousel.component.html',
    styleUrls: ['./image-carousel.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatProgressSpinnerModule, MatIconModule, AsyncPipe]
})
export class ImageCarouselComponent implements OnInit {

  @Input() showThumbnails = false;
  
  carImagesFolder$: Observable<FileData[] | undefined > ;

  carImagesFolder: FileData[] = [];

  currentImageIndex: number = 0;

  currentImageIndexSubject$: BehaviorSubject<number>;

  currentImage: any
  currentDealerImage: any
  
  isSeller: boolean = false;

  favorites: string[] = [];

  fetchingImage: boolean = true;
   
  constructor(

    private store: Store, 
    private router: Router, 
    public route: ActivatedRoute,
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog,
    private _location: Location
    ) {

      this.currentImageIndexSubject$ = new BehaviorSubject<number>(0);
      this.carImagesFolder$ = store.select(selectCurrentCarImagesDatas);
    }

  ngOnInit(): void {

    this.carImagesFolder$.subscribe(
      (imgdts) => {
          this.carImagesFolder = imgdts!;
          this.currentImage = this.getCarImage(0);
      });

    this.currentImageIndexSubject$.subscribe(
      (i: number) =>  {
        this.currentImage = this.getCarImage(i);
      }
    );

    this.currentImage = this.getCarImage(0);

  }

  ngOnChanges(changes: SimpleChanges): void {
    
    const latestImagesFolder = changes['carImagesFolder'];
    if (latestImagesFolder != undefined) {
      if ((latestImagesFolder.currentValue?.length as number) === 1) {
        
        this.currentImageIndexSubject$.next(0);
      }
    }
  }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  getCarImage(i: number): any{

    if(this.carImagesFolder != undefined && this.carImagesFolder.length > 0 ){
      let objectUrl = URL.createObjectURL(this.carImagesFolder[i].blob);     
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
    }
  }

  nextImage(): void{
    console.log("current = "+this.currentImageIndex);

    if(this.currentImageIndex === this.carImagesFolder!.length-1)
      this.currentImageIndex = 0;
    else 
      this.currentImageIndex++;
    console.log("next = "+this.currentImageIndex);
    this.currentImageIndexSubject$.next(this.currentImageIndex);
  }

  prevImage(): void{
    console.log("current ="+this.currentImageIndex);
    if(this.currentImageIndex === 0 )
      this.currentImageIndex = this.carImagesFolder!.length-1;
    else 
      this.currentImageIndex--;
    
    console.log("prev ="+this.currentImageIndex);
    this.currentImageIndexSubject$.next(this.currentImageIndex);
  }

  selectImage(index: number): void{
    this.currentImageIndex = index;
    this.currentImageIndexSubject$.next(this.currentImageIndex);
  }

  uploadImage(carId: string, event: any, ): void {

    let files: File[] = event.target.files;
    console.log('file name = '+files[0].name);

    if(files != undefined && files.length > 0){
      this.store.dispatch(FilesActions.uploadCarImageSubmit({ carId: carId, file: files[0] }));
    }
  }

}

